import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';

/**
 * Generated class for the ConfigurationPaymentCryptoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-getnet-top',
  templateUrl: 'configuration-payment-getnet-top.html',
})
export class ConfigurationPaymentGetnetTopPage {

  public redsys_top_user_id: number;
  public redsys_top_user_token_hidden: string = '';
  public redsys_top_client_id: string = 'd3912014b45e4422aa772c05a0ecdc2d';
  public redsys_top_merchant_id: number;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController) {


  }

  ionViewWillEnter() {

    if (this.globals.restaurant.payment_method_redsys_top_user_id != undefined) {
      this.redsys_top_user_id = this.globals.restaurant.payment_method_redsys_top_user_id;
    } else {  //no exist generate user_id
      this.redsys_top_user_id = Math.floor(Date.now() / 1000);
    }
    if (this.globals.restaurant.payment_method_redsys_top_user_token != undefined) {
      this.redsys_top_user_token_hidden = this.globals.restaurant.payment_method_redsys_top_user_token;
    } else { //no exist generate token
      this.redsys_top_user_token_hidden = uuidv4() + '-' + Date.now() + '-' + uuidv4() + '-' + Date.now() + '-' + uuidv4();
    }
    if (this.globals.restaurant.payment_method_redsys_top_client_id != undefined) {
      this.redsys_top_client_id = this.globals.restaurant.payment_method_redsys_top_client_id;
    }
    if (this.globals.restaurant.payment_method_redsys_top_merchant_id != undefined) {
      this.redsys_top_merchant_id = this.globals.restaurant.payment_method_redsys_top_merchant_id;
    }
  }

  changeGetnetTop(active) {
    if (this.redsys_top_user_id && this.redsys_top_user_token_hidden != '' && this.redsys_top_client_id != '' && this.redsys_top_merchant_id) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_top': active,
        'payment_method_redsys_top_user_id': this.redsys_top_user_id,
        'payment_method_redsys_top_user_token': this.redsys_top_user_token_hidden,
        'payment_method_redsys_top_client_id': this.redsys_top_client_id,
        'payment_method_redsys_top_merchant_id': this.redsys_top_merchant_id,
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_top = active;
        this.globals.restaurant.payment_method_redsys_top_user_id = this.redsys_top_user_id;
        this.globals.restaurant.payment_method_redsys_top_user_token = this.redsys_top_user_token_hidden;
        this.globals.restaurant.payment_method_redsys_top_client_id = this.redsys_top_client_id;
        this.globals.restaurant.payment_method_redsys_top_merchant_id = this.redsys_top_merchant_id;
      });
      //toast
      let toast = this.toastCtrl.create({
        message: active ? this.translate.instant('config-activado') : this.translate.instant('config-desactivado'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    } else {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_top': false
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_top = false;
      });
      //toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-faltan-datos'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    }
  }

  saveConfig() {
    if (this.redsys_top_user_id && this.redsys_top_user_token_hidden != '' && this.redsys_top_client_id != '' && this.redsys_top_merchant_id) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_redsys_top_user_id': this.redsys_top_user_id,
        'payment_method_redsys_top_user_token': this.redsys_top_user_token_hidden,
        'payment_method_redsys_top_client_id': this.redsys_top_client_id,
        'payment_method_redsys_top_merchant_id': this.redsys_top_merchant_id,
      }).then(() => {
        this.globals.restaurant.payment_method_redsys_top_user_id = this.redsys_top_user_id;
        this.globals.restaurant.payment_method_redsys_top_user_token = this.redsys_top_user_token_hidden;
        this.globals.restaurant.payment_method_redsys_top_client_id = this.redsys_top_client_id;
        this.globals.restaurant.payment_method_redsys_top_merchant_id = this.redsys_top_merchant_id;

        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-guardado-correctamente'),
          duration: 2000,
          position: 'top'
        });
        toast.present();
        this.changeGetnetTop(true);

      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-faltan-datos'),
        duration: 2000,
        position: 'top'
      });
      toast.present();
      this.changeGetnetTop(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-getnet-top/configuration-payment-getnet-top.ts